import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Button,
  Select,
  SelectItem,
} from '@heroui/react';
import React, { useState } from 'react';
import { OrderStatuses } from '../../types/orders';

interface CardStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (orderStatus?: string) => void;
  currentStatus?: string;
  columnName: string;
}

const CardStatusModal: React.FC<CardStatusModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  currentStatus,
  columnName,
}) => {
  const [selectedStatus, setSelectedStatus] = useState<string>('');
  const [updateStatus, setUpdateStatus] = useState<boolean>(false);

  const handleConfirm = () => {
    if (updateStatus && selectedStatus) {
      onConfirm(selectedStatus);
    } else {
      onConfirm(undefined); // Leave status as-is
    }
    handleClose();
  };

  const handleClose = () => {
    setSelectedStatus('');
    setUpdateStatus(false);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size='md'
      scrollBehavior='inside'
      classNames={{
        base: 'max-h-[90vh]',
        body: 'overflow-y-auto',
      }}
    >
      <ModalContent>
        <ModalHeader>Move Card to {columnName}</ModalHeader>
        <ModalBody>
          <div className='space-y-4'>
            <p className='text-sm text-gray-600'>
              The card will be moved to the <strong>{columnName}</strong>{' '}
              column. Would you like to update the order status?
            </p>

            <div className='flex items-center gap-2'>
              <input
                type='checkbox'
                id='updateStatus'
                checked={updateStatus}
                onChange={e => setUpdateStatus(e.target.checked)}
                className='rounded'
              />
              <label htmlFor='updateStatus' className='text-sm text-gray-700'>
                Update order status
              </label>
            </div>

            {updateStatus && (
              <Select
                label='Order Status'
                placeholder='Select status'
                selectedKeys={selectedStatus ? [selectedStatus] : []}
                onSelectionChange={keys => {
                  const selected = Array.from(keys)[0] as string;
                  setSelectedStatus(selected || '');
                }}
              >
                {OrderStatuses.map(status => (
                  <SelectItem key={status}>{status}</SelectItem>
                ))}
              </Select>
            )}

            {currentStatus && (
              <p className='text-xs text-gray-500'>
                Current status: <strong>{currentStatus}</strong>
              </p>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button variant='ghost' onClick={handleClose}>
            Cancel
          </Button>
          <Button color='primary' onClick={handleConfirm}>
            Move Card
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CardStatusModal;
